import React from 'react';

export default function Footer({ navigate, user, onAuthClick }) {
  const currentYear = new Date().getFullYear();

  const handleLink = (route) => (e) => {
    e.preventDefault();
    const ENABLE_AUTH = false; // Set to true to re-enable authentication lock
    const isVerifiedUser = user && user.emailVerified;
    const isProtectedRoute = ['functions', 'shortcuts', 'skill-test', 'training'].includes(route);
    if (ENABLE_AUTH && isProtectedRoute && !isVerifiedUser) {
      onAuthClick('login');
    } else {
      navigate(route);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="footer-brand">
              <span className="brand-green">Mr Excel</span> Sri Lanka
            </div>
            <p>
              Practical Excel training, Workplace Learning and automation solutions for professionals and corporate teams
            </p>
            <p>
              <strong>info@mrexcelsrilanka.com</strong>
              <br />
              070 523 3369
            </p>
          </div>
          <div>
            <h3>Explore</h3>
            <a href="#/functions" onClick={handleLink('functions')}>
              Function Library
            </a>
            <a href="#/shortcuts" onClick={handleLink('shortcuts')}>
              Shortcut Library
            </a>
            <a href="#/skill-test" onClick={handleLink('skill-test')}>
              Excel Skill Test
            </a>
          </div>
          <div>
            <h3>Resources</h3>
            <a href="#/training" onClick={handleLink('training')}>
              Career Insights
            </a>
            <a href="#/contact" onClick={handleLink('contact')}>
              Contact
            </a>
          </div>
          <div>
            <h3>Training</h3>
            <a href="#/contact" onClick={handleLink('contact')}>
              Request Corporate Training
            </a>
            <a href="#/contact" onClick={handleLink('contact')}>
              Onsite Training
            </a>
            <a href="#/contact" onClick={handleLink('contact')}>
              Online Training
            </a>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {currentYear} Mr Excel Sri Lanka. All rights reserved.</span>
          <span>Practical workplace Excel learning.</span>
        </div>
      </div>
    </footer>
  );
}
